import styled from '@emotion/styled/macro';
import { css } from '@emotion/react';
import { Button } from '@mui/material';

interface StyledVoteProps {
  color: string;
}

export const StyledUpperSection = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin: 32px 0px;
`;

export const StyledVoting = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 64px;
`;

export const StyledPool = styled.div`
  margin-right: 32px;
`;

export const StyledVotes = styled.div<{ count: number }>`
  display: grid;
  gap: 4px;
  grid-auto-columns: 32px;
  grid-auto-flow: column;

  ${({ count }) =>
    count &&
    css`
      grid-template-rows: ${'1fr '.repeat(Math.ceil(count / 9))};
    `}
`;

export const StyledVoteDetail = styled.div`
  display: none;
  position: absolute;
  left: 10px;
  top: 10px;
  min-width: 125px;
  padding: 6px;
  background-color: white;
  border: 1px solid black;
  border-radius: 4px;
  z-index: 1;
  white-space: nowrap;
`;

export const StyledVoteDetailParty = styled.div``;

export const StyledVote = styled.div<StyledVoteProps>`
  position: relative;
  height: 32px;
  align-self: end;
  background-color: ${(props) => props.color};
  cursor: pointer;

  &:hover {
    ${StyledVoteDetail} {
      display: block;
    }
  }
`;

export const StyledParty = styled.div``;

export const StyledButton = styled(Button)`
  font: inherit;
  color: black;
  border-color: black;
  transition-duration: 0s !important;

  &:hover,
  &:active {
    color: black;
    background-color: white;
    border: 1px solid black;
  }
`;

export const StyledDivider = styled.div`
  width: 2px;
  height: 18px;
  background-color: black;
`;

export const StyledMainSection = styled.div`
  margin-bottom: 32px;
`;

export const StyledDetailSection = styled.div`
  margin-bottom: 32px;
`;

export const StyledVotingInfo = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const StyledDetailResultVote = styled.div`
  margin-top: 10px;
  display: flex;
`;

export const StyledDetailResultVoteParty = styled.div<StyledVoteProps>`
  color: transparent;
  width: 24px;
  height: 24px;
  margin-right: 8px;
  background-color: ${(props) => props.color};
`;
